import { isLocalEnvironment } from './environment';

export const ANON_ID_COOKIE = 'ajs_anonymous_id';
// Set by the @1debit/analytics SDK on identify; scoped to *.chime.com.
export const CHIME_USER_ID_COOKIE = 'chime_user_id';
export const VISITOR_ID_TRACKED_COOKIE = 'ajs_visitor_id_tracked';
export const EMAIL_CAPTURE_COOKIE = 'landing_email';
export const NINETAILED_ANONYMOUS_ID_COOKIE = 'ntaid';
export const REFERRAL_TOKEN_COOKIE = 'referral_token';
export const REFERRER_NAME_COOKIE = 'referrer_name';
export const REFERRER_USER_ID_COOKIE = 'referrer_user_id';
export const INCENTIVE_FIELDS_COOKIE = 'incentive_fields';
export const CUSTOM_QSP_COOKIE = 'custom_qsp';
export const JOINT_CHECKING_TOKEN_COOKIE = 'joint_checking_token';
export const LAST_CAMPAIGN_COOKIE = 'last_campaign';
export const FP_VIEWED_COOKIE = 'fpViewed';
export const SAVED_JOBS_COOKIE = 'SavedJobs';
export const ONETRUST_CONSENT_COOKIE = 'OptanonConsent';
export const ONETRUST_BANNER_CLOSED_COOKIE = 'OptanonAlertBoxClosed';
export const BANNER_COOKIE_PREFIX = 'banner-';

export interface CookieOptions {
  secure: boolean;
  httpOnly?: boolean;
  sameSite: 'lax' | 'strict' | 'none';
  expires?: Date;
  domain?: string;
  path?: string;
  maxAge?: number;
}

const getBaseCookieOptions = (): Omit<CookieOptions, 'secure'> => ({
  sameSite: 'lax',
  domain: isLocalEnvironment() ? undefined : 'chime.com',
  path: '/',
  maxAge: 365 * 24 * 60 * 60, // 1 year
});

export interface CreateCookieOptionsConfig {
  cookieOptions?: Partial<CookieOptions>;
  enableCrossSubdomain?: boolean;
}

/**
 * Factory function to create cookie options with optional cross-subdomain sharing
 * @param config - Configuration object with cookieOptions and enableCrossSubdomain
 * @returns Merged cookie options
 * @note If both cookieOptions.domain and enableCrossSubdomain are provided, cookieOptions.domain takes precedence
 */
export const createCookieOptions = (config: CreateCookieOptionsConfig = {}): CookieOptions => {
  const { cookieOptions = {}, enableCrossSubdomain = false } = config;
  const baseOptions = getBaseCookieOptions();

  if (enableCrossSubdomain) {
    baseOptions.domain = isLocalEnvironment() ? 'localhost' : '.chime.com';
  }

  const merged = { ...baseOptions, ...cookieOptions };

  // Apply secure cookie attribute unconditionally
  return { ...merged, secure: true };
};
